module.exports = "<fuse-navigation layout=\"horizontal\"></fuse-navigation>\n"


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module id = ../../../../../src/app/main/navbar/horizontal/navbar-horizontal.component.html
// module chunks = main